<div fxLayout="column">
  <div
    class="body-question-wrapper-mobile"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="5%"
  >
    <div
      class="button-container"
      fxLayout="column"
      fxLayoutAlign="space-between"
    >
      <mat-button-toggle-group fxFlex="100">
        <mat-button-toggle
          fxFlex
          fxLayoutAlign="center center"
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.head }"
          (click)="toggleSelection('head')"
        >
          {{ 'patient-intake.body-selector.head' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>

      <mat-card-subtitle>
        {{ 'patient-intake.body-selector.neck' | translate }}
      </mat-card-subtitle>
      <mat-button-toggle-group fxFlex="100" fxLayout="row">
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.neckLeft }"
          (click)="toggleSelection('neckLeft')"
        >
          {{ 'patient-intake.body-selector.neck-left' | translate }}
        </mat-button-toggle>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.neckRight }"
          (click)="toggleSelection('neckRight')"
        >
          {{ 'patient-intake.body-selector.neck-right' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>

      <mat-card-subtitle>
        {{ 'patient-intake.body-selector.shoulder' | translate }}
      </mat-card-subtitle>
      <mat-button-toggle-group>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.shoulderLeft }"
          (click)="toggleSelection('shoulderLeft')"
        >
          {{ 'patient-intake.body-selector.shoulder-left' | translate }}
        </mat-button-toggle>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.shoulderRight }"
          (click)="toggleSelection('shoulderRight')"
        >
          {{ 'patient-intake.body-selector.shoulder-right' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>

      <mat-card-subtitle>
        {{ 'patient-intake.body-selector.upper-back' | translate }}
      </mat-card-subtitle>
      <mat-button-toggle-group>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.upperBackLeft }"
          (click)="toggleSelection('upperBackLeft')"
        >
          {{ 'patient-intake.body-selector.upper-back-left' | translate }}
        </mat-button-toggle>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.upperBackRight }"
          (click)="toggleSelection('upperBackRight')"
        >
          {{ 'patient-intake.body-selector.upper-back-right' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>

      <mat-card-subtitle>
        {{ 'patient-intake.body-selector.lower-back' | translate }}
      </mat-card-subtitle>
      <mat-button-toggle-group>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.lowerBackLeft }"
          (click)="toggleSelection('lowerBackLeft')"
        >
          {{ 'patient-intake.body-selector.lower-back-left' | translate }}
        </mat-button-toggle>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.lowerBackRight }"
          (click)="toggleSelection('lowerBackRight')"
        >
          {{ 'patient-intake.body-selector.lower-back-right' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>

      <mat-card-subtitle>
        {{ 'patient-intake.body-selector.arm' | translate }}
      </mat-card-subtitle>
      <mat-button-toggle-group>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.armLeft }"
          (click)="toggleSelection('armLeft')"
        >
          {{ 'patient-intake.body-selector.arm-left' | translate }}
        </mat-button-toggle>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.armRight }"
          (click)="toggleSelection('armRight')"
        >
          {{ 'patient-intake.body-selector.arm-right' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>

      <mat-card-subtitle>
        {{ 'patient-intake.body-selector.hand' | translate }}
      </mat-card-subtitle>
      <mat-button-toggle-group>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.handLeft }"
          (click)="toggleSelection('handLeft')"
        >
          {{ 'patient-intake.body-selector.hand-left' | translate }}
        </mat-button-toggle>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.handRight }"
          (click)="toggleSelection('handRight')"
        >
          {{ 'patient-intake.body-selector.hand-right' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>

      <mat-card-subtitle>
        {{ 'patient-intake.body-selector.glutes' | translate }}
      </mat-card-subtitle>
      <mat-button-toggle-group>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.glutesLeft }"
          (click)="toggleSelection('glutesLeft')"
        >
          {{ 'patient-intake.body-selector.glutes-left' | translate }}
        </mat-button-toggle>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.glutesRight }"
          (click)="toggleSelection('glutesRight')"
        >
          {{ 'patient-intake.body-selector.glutes-right' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>

      <mat-card-subtitle>
        {{ 'patient-intake.body-selector.leg' | translate }}
      </mat-card-subtitle>
      <mat-button-toggle-group>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.legLeft }"
          (click)="toggleSelection('legLeft')"
        >
          {{ 'patient-intake.body-selector.leg-left' | translate }}
        </mat-button-toggle>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.legRight }"
          (click)="toggleSelection('legRight')"
        >
          {{ 'patient-intake.body-selector.leg-right' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>

      <mat-card-subtitle>
        {{ 'patient-intake.body-selector.feet' | translate }}
      </mat-card-subtitle>
      <mat-button-toggle-group>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.feetLeft }"
          (click)="toggleSelection('feetLeft')"
        >
          {{ 'patient-intake.body-selector.feet-left' | translate }}
        </mat-button-toggle>
        <mat-button-toggle
          class="green-btn-outline"
          [ngClass]="{ active: bodyParts.feetRight }"
          (click)="toggleSelection('feetRight')"
        >
          {{ 'patient-intake.body-selector.feet-right' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div
      class="body-diagram-container"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <div class="body-diagram-parts">
        <img src="../../../../assets/images/body-diagram/base-consumer.jpg" />
        <img
          *ngIf="bodyParts.head"
          src="../../../../assets/images/body-diagram/head.png"
          class="body-diagram-head"
        />
        <img
          *ngIf="bodyParts.armLeft"
          src="../../../../assets/images/body-diagram/arms-left.png"
          class="body-diagram-arms-left"
        />
        <img
          *ngIf="bodyParts.armRight"
          src="../../../../assets/images/body-diagram/arms-right.png"
          class="body-diagram-arms-right"
        />
        <img
          *ngIf="bodyParts.upperBackLeft"
          src="../../../../assets/images/body-diagram/back-upper-left.png"
          class="body-diagram-back-upper-left"
        />
        <img
          *ngIf="bodyParts.upperBackRight"
          src="../../../../assets/images/body-diagram/back-upper-right.png"
          class="body-diagram-back-upper-right"
        />
        <img
          *ngIf="bodyParts.lowerBackLeft"
          src="../../../../assets/images/body-diagram/back-lower-left.png"
          class="body-diagram-back-lower-left"
        />
        <img
          *ngIf="bodyParts.lowerBackRight"
          src="../../../../assets/images/body-diagram/back-lower-right.png"
          class="body-diagram-back-lower-right"
        />
        <img
          *ngIf="bodyParts.feetLeft"
          src="../../../../assets/images/body-diagram/feet-left.png"
          class="body-diagram-feet-left"
        />
        <img
          *ngIf="bodyParts.feetRight"
          src="../../../../assets/images/body-diagram/feet-right.png"
          class="body-diagram-feet-right"
        />
        <img
          *ngIf="bodyParts.glutesLeft"
          src="../../../../assets/images/body-diagram/glutes-left.png"
          class="body-diagram-glutes-left"
        />
        <img
          *ngIf="bodyParts.glutesRight"
          src="../../../../assets/images/body-diagram/glutes-right.png"
          class="body-diagram-glutes-right"
        />
        <img
          *ngIf="bodyParts.handLeft"
          src="../../../../assets/images/body-diagram/hand-left.png"
          class="body-diagram-hand-left"
        />
        <img
          *ngIf="bodyParts.handRight"
          src="../../../../assets/images/body-diagram/hand-right.png"
          class="body-diagram-hand-right"
        />
        <img
          *ngIf="bodyParts.legLeft"
          src="../../../../assets/images/body-diagram/legs-left.png"
          class="body-diagram-legs-left"
        />
        <img
          *ngIf="bodyParts.legRight"
          src="../../../../assets/images/body-diagram/legs-right.png"
          class="body-diagram-legs-right"
        />
        <img
          *ngIf="bodyParts.neckLeft"
          src="../../../../assets/images/body-diagram/neck-left.png"
          class="body-diagram-neck-left"
        />
        <img
          *ngIf="bodyParts.neckRight"
          src="../../../../assets/images/body-diagram/neck-right.png"
          class="body-diagram-neck-right"
        />
        <img
          *ngIf="bodyParts.shoulderLeft"
          src="../../../../assets/images/body-diagram/shoulders-left.png"
          class="body-diagram-shoulders-left"
        />
        <img
          *ngIf="bodyParts.shoulderRight"
          src="../../../../assets/images/body-diagram/shoulders-right.png"
          class="body-diagram-shoulders-right"
        />
      </div>
    </div>
  </div>

  <div
    class="body-question-wrapper"
    fxLayout="row"
    fxLayoutAlign="space-between"
    fxLayoutAlign.gt-md="start"
    fxLayoutGap="5%"
  >
    <div
      class="button-container"
      fxLayout="column"
      fxLayoutAlign="space-between"
      fxLayoutGap="5%"
    >
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.neckLeft }"
        (click)="toggleSelection('neckLeft')"
      >
        {{ 'patient-intake.body-selector.neck-left' | translate }}
      </mat-button-toggle>
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.shoulderLeft }"
        (click)="toggleSelection('shoulderLeft')"
      >
        {{ 'patient-intake.body-selector.shoulder-left' | translate }}
      </mat-button-toggle>
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.upperBackLeft }"
        (click)="toggleSelection('upperBackLeft')"
      >
        {{ 'patient-intake.body-selector.upper-back-left' | translate }}
      </mat-button-toggle>
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.lowerBackLeft }"
        (click)="toggleSelection('lowerBackLeft')"
      >
        {{ 'patient-intake.body-selector.lower-back-left' | translate }}
      </mat-button-toggle>
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.armLeft }"
        (click)="toggleSelection('armLeft')"
      >
        {{ 'patient-intake.body-selector.arm-left' | translate }}
      </mat-button-toggle>
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.handLeft }"
        (click)="toggleSelection('handLeft')"
      >
        {{ 'patient-intake.body-selector.hand-left' | translate }}
      </mat-button-toggle>
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.glutesLeft }"
        (click)="toggleSelection('glutesLeft')"
      >
        {{ 'patient-intake.body-selector.glutes-left' | translate }}
      </mat-button-toggle>
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.legLeft }"
        (click)="toggleSelection('legLeft')"
      >
        {{ 'patient-intake.body-selector.leg-left' | translate }}
      </mat-button-toggle>
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.feetLeft }"
        (click)="toggleSelection('feetLeft')"
      >
        {{ 'patient-intake.body-selector.feet-left' | translate }}
      </mat-button-toggle>
    </div>

    <div
      class="body-diagram-container"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <div style="margin-bottom: 5%">
        <mat-button-toggle-group fxFlex="100">
          <mat-button-toggle
            fxFlex
            fxLayoutAlign="center center"
            class="green-btn-outline"
            [ngClass]="{ active: bodyParts.head }"
            (click)="toggleSelection('head')"
          >
            {{ 'patient-intake.body-selector.head' | translate }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="body-diagram-parts">
        <img src="../../../../assets/images/body-diagram/base-consumer.jpg" />
        <img
          *ngIf="bodyParts.head"
          src="../../../../assets/images/body-diagram/head.png"
          class="body-diagram-head"
        />
        <img
          *ngIf="bodyParts.armLeft"
          src="../../../../assets/images/body-diagram/arms-left.png"
          class="body-diagram-arms-left"
        />
        <img
          *ngIf="bodyParts.armRight"
          src="../../../../assets/images/body-diagram/arms-right.png"
          class="body-diagram-arms-right"
        />
        <img
          *ngIf="bodyParts.upperBackLeft"
          src="../../../../assets/images/body-diagram/back-upper-left.png"
          class="body-diagram-back-upper-left"
        />
        <img
          *ngIf="bodyParts.upperBackRight"
          src="../../../../assets/images/body-diagram/back-upper-right.png"
          class="body-diagram-back-upper-right"
        />
        <img
          *ngIf="bodyParts.lowerBackLeft"
          src="../../../../assets/images/body-diagram/back-lower-left.png"
          class="body-diagram-back-lower-left"
        />
        <img
          *ngIf="bodyParts.lowerBackRight"
          src="../../../../assets/images/body-diagram/back-lower-right.png"
          class="body-diagram-back-lower-right"
        />
        <img
          *ngIf="bodyParts.feetLeft"
          src="../../../../assets/images/body-diagram/feet-left.png"
          class="body-diagram-feet-left"
        />
        <img
          *ngIf="bodyParts.feetRight"
          src="../../../../assets/images/body-diagram/feet-right.png"
          class="body-diagram-feet-right"
        />
        <img
          *ngIf="bodyParts.glutesLeft"
          src="../../../../assets/images/body-diagram/glutes-left.png"
          class="body-diagram-glutes-left"
        />
        <img
          *ngIf="bodyParts.glutesRight"
          src="../../../../assets/images/body-diagram/glutes-right.png"
          class="body-diagram-glutes-right"
        />
        <img
          *ngIf="bodyParts.handLeft"
          src="../../../../assets/images/body-diagram/hand-left.png"
          class="body-diagram-hand-left"
        />
        <img
          *ngIf="bodyParts.handRight"
          src="../../../../assets/images/body-diagram/hand-right.png"
          class="body-diagram-hand-right"
        />
        <img
          *ngIf="bodyParts.legLeft"
          src="../../../../assets/images/body-diagram/legs-left.png"
          class="body-diagram-legs-left"
        />
        <img
          *ngIf="bodyParts.legRight"
          src="../../../../assets/images/body-diagram/legs-right.png"
          class="body-diagram-legs-right"
        />
        <img
          *ngIf="bodyParts.neckLeft"
          src="../../../../assets/images/body-diagram/neck-left.png"
          class="body-diagram-neck-left"
        />
        <img
          *ngIf="bodyParts.neckRight"
          src="../../../../assets/images/body-diagram/neck-right.png"
          class="body-diagram-neck-right"
        />
        <img
          *ngIf="bodyParts.shoulderLeft"
          src="../../../../assets/images/body-diagram/shoulders-left.png"
          class="body-diagram-shoulders-left"
        />
        <img
          *ngIf="bodyParts.shoulderRight"
          src="../../../../assets/images/body-diagram/shoulders-right.png"
          class="body-diagram-shoulders-right"
        />
      </div>
    </div>

    <div
      class="button-container"
      fxLayout="column"
      fxLayoutAlign="space-between"
      fxLayoutGap="5%"
    >
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.neckRight }"
        (click)="toggleSelection('neckRight')"
      >
        {{ 'patient-intake.body-selector.neck-right' | translate }}
      </mat-button-toggle>
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.shoulderRight }"
        (click)="toggleSelection('shoulderRight')"
      >
        {{ 'patient-intake.body-selector.shoulder-right' | translate }}
      </mat-button-toggle>
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.upperBackRight }"
        (click)="toggleSelection('upperBackRight')"
      >
        {{ 'patient-intake.body-selector.upper-back-right' | translate }}
      </mat-button-toggle>
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.lowerBackRight }"
        (click)="toggleSelection('lowerBackRight')"
      >
        {{ 'patient-intake.body-selector.lower-back-right' | translate }}
      </mat-button-toggle>
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.armRight }"
        (click)="toggleSelection('armRight')"
      >
        {{ 'patient-intake.body-selector.arm-right' | translate }}
      </mat-button-toggle>
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.handRight }"
        (click)="toggleSelection('handRight')"
      >
        {{ 'patient-intake.body-selector.hand-right' | translate }}
      </mat-button-toggle>
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.glutesRight }"
        (click)="toggleSelection('glutesRight')"
      >
        {{ 'patient-intake.body-selector.glutes-right' | translate }}
      </mat-button-toggle>
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.legRight }"
        (click)="toggleSelection('legRight')"
      >
        {{ 'patient-intake.body-selector.leg-right' | translate }}
      </mat-button-toggle>
      <mat-button-toggle
        class="green-btn-outline"
        [ngClass]="{ active: bodyParts.feetRight }"
        (click)="toggleSelection('feetRight')"
      >
        {{ 'patient-intake.body-selector.feet-right' | translate }}
      </mat-button-toggle>
    </div>
  </div>
</div>
